import { useEffect } from "react";
import { useLocation } from "../router";

/* Adds an `.in` class to any `.reveal` element as it enters the viewport.
   Re-scans on every route change so newly mounted pages animate too. */
export default function useReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal:not(.in)"));
    if (!("IntersectionObserver" in window) || els.length === 0) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    // small timeout so freshly-routed DOM is present
    const t = setTimeout(() => els.forEach((el) => io.observe(el)), 60);
    return () => {
      clearTimeout(t);
      io.disconnect();
    };
  }, [pathname]);
}
